import React from 'react';
import { motion } from 'framer-motion';
import { CountdownTimer } from './CountdownTimer';
import { PricingCards } from './PricingCards';
export function FinalCta() {
  return <section className="py-24 md:py-32 px-4 bg-bg-card" data-id="element-99">
      <div className="max-w-6xl mx-auto" data-id="element-100">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-14" data-id="element-101">
          <h2 className="text-text-primary font-display font-bold text-2xl md:text-3xl mb-8 tracking-wide" data-id="element-102">
            ⏰ PRECIO DE LANZAMIENTO — CIERRA EN:
          </h2>
          <CountdownTimer className="mb-8" data-id="element-103" />
        </motion.div>

        <PricingCards className="mb-14" data-id="element-104" />

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="flex flex-wrap justify-center gap-4 text-[13px] text-text-secondary" data-id="element-105">
          <span className="flex items-center gap-2 bg-bg-input border border-border-subtle rounded-full px-4 py-2" data-id="element-106">
            🔒 Pago 100% seguro
          </span>
          <span className="flex items-center gap-2 bg-bg-input border border-border-subtle rounded-full px-4 py-2" data-id="element-107">
            ⚡ Acceso en 5 min
          </span>
          <span className="flex items-center gap-2 bg-bg-input border border-border-subtle rounded-full px-4 py-2" data-id="element-108">
            🛡️ Garantía 7 días
          </span>
          <span className="flex items-center gap-2 bg-bg-input border border-border-subtle rounded-full px-4 py-2" data-id="element-109">
            💳 Mercado Pago
          </span>
        </motion.div>
      </div>
    </section>;
}